import {
    Button,
    Card,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {useSelector} from "../../redux/store";
import {useEffect, useState} from "react";
import {INVOICE_TYPE, PAYMENT_TYPE, SETTINGS_PAYMENTS, TRANSACTION_TYPE} from "../../constants";
import moment from "moment";
import {calculateBasicOfItem} from "../../helper/other";
import {Invoice} from "../../helper/invoice/Invoice";
import {useSnackbar} from "notistack";
import {LoadingButton, ToggleButtonGroup} from "@mui/lab";
import MethodButton from "../../components/MethodButton";
import {alpha} from "@mui/material/styles";
import {fCurrency} from "../../utils/formatNumber";
import {getCashierName} from "../../utils/other";
import {useAuthContext} from "../../auth/useAuthContext";
import { upsertPlatformTicket } from "../../api/barriers";

export default function PlatformDialog({
                                           printedInvoices,
                                           setPrintedInvoices,
                                           additional,
                                           open,
                                           onClose,
                                           onSuccess
                                       }) {

    const {enqueueSnackbar} = useSnackbar();
    const {user} = useAuthContext();
    const {allItemsList} = useSelector(state => state.items);
    const {roundedPrice,} = useSelector(state => state.userSettings);
    const {currentTaxRates} = useSelector(((state) => state.taxCore));
    const {settings, userImage, silentPrint, printerSize, ticketLogo} = useSelector(state => state.settings);

    const [selectedPayments, setSelectedPayments] = useState([]);
    const [exchange, setExchange] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);

    const item = allItemsList.find(item => item.includeOnPlatform === true);
    const total = (item?.price || 0) * quantity

    const roundTotal = roundedPrice ? Math.ceil(total / 10) * 10 : total

    let showExchange = selectedPayments.length === 1 && selectedPayments[0].paymentType === PAYMENT_TYPE.cash && settings?.change;
    const filteredPayments = SETTINGS_PAYMENTS.filter(value => !!settings?.[value.name]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            setSelectedPayments([{
                paymentType: PAYMENT_TYPE.cash,
                amount: roundTotal
            }]);
            setExchange(0);
        }
        return () => isMounted = false;
    }, [roundTotal]);

    const handleMethodClick = (method, isDouble) => {
        if (isDouble) {
            setSelectedPayments([{
                paymentType: method.value,
                amount: roundTotal
            }]);
        } else {
            let arr = [...selectedPayments];
            let index = arr.findIndex(localMethod => localMethod.paymentType === method.value);
            if (index === -1) {
                arr.push({
                    paymentType: method.value,
                    amount: 0
                });
            } else {
                arr.splice(index, 1);
            }
            if (arr.length > 1) {
                arr = arr.map(value => ({
                    ...value,
                    amount: 0
                }));
            } else {
                arr = arr.map(value => ({
                    ...value,
                    amount: roundTotal
                }));
            }
            setSelectedPayments(arr);
        }
        setExchange(0);
    };

    const handleChangeAmount = (event, index) => {
        const {name, value} = event.target;
        const rawValue = value.replace(',', '.');
        let arr = [...selectedPayments];
        let sumAll = arr.filter(localMethod => localMethod.paymentType !== name).reduce((acc, {amount}) => acc + amount, 0);
        let amount = Number(Number(rawValue).toFixed(2));
        let newAmount = Number(Number(sumAll + amount <= roundTotal ? amount : roundTotal - sumAll).toFixed(2));
        arr[index] = {
            ...arr[index],
            amount: showExchange ? amount : newAmount
        };
        if (showExchange) {
            setExchange(Number(Number(amount - roundTotal).toFixed(2)));
        }
        setSelectedPayments(arr);
    };

    const handleIssuePlatformCard = async (e) => {
        try {
            setLoading(true)
            e.preventDefault();
            const arr = [...printedInvoices]
            if (!item) {
                return enqueueSnackbar("Ne postoji proizvod/usluga za izdavanje!", {variant: "warning"});
            }
            let sumAll = selectedPayments.reduce((acc, {amount}) => acc + amount, 0);
            if (showExchange) {
                sumAll = sumAll - exchange;
            }
            if (sumAll !== roundTotal) {
                return enqueueSnackbar("Zbir plaćanja mora biti isti kao i ukupan iznos", {variant: "warning"});
            }
            let localExchange = exchange < 0 ? 0 : exchange;
            let payment = selectedPayments;
            if (selectedPayments.length === 1) {
                payment = selectedPayments.map(value => ({
                    ...value,
                    amount: roundTotal
                }));
            }
            const base = calculateBasicOfItem({
                ...item,
                unitPrice: item.price,
                quantity: 1
            }, currentTaxRates);
            const invoice = new Invoice();
            invoice.setItems([{
                ...item,
                totalAmount: item.price * quantity,
                name: item.name,
                quantity: quantity,
                labels: [item.vat],
                unitPrice: item.price,
                baseAmount: base,
                pdv: item.price - base,
                cashier: getCashierName(),
                salesTime: moment().format("YYYY-MM-DD HH:mm:ss"),
            }])
            invoice.setRoundedPrice = roundedPrice;
            invoice.setPayments(payment);
            invoice.setInvoiceType(INVOICE_TYPE.normal);

            invoice.setTransactionType(TRANSACTION_TYPE.sale)
            // invoice.setBuyerIdFromCustomer(customer)
            // OTHER
            invoice.setInternalData({
                peronTicket: true,
                barrierId: -1,
                barrierQuantity: quantity,
                client: "webBus",
                lineName: additional.lineName || null,
                selectedLine: additional?.selectedLine || null,
                departureTripTime: additional.departureTripTime || null,
                startStation: additional?.startStation || null,
                endStation: additional?.endStation || null,
                operatorId: additional?.operatorId || null,
                //issuedFor: additional?.issuedFor
            })
            invoice.setSilentPrint(silentPrint)
            invoice.setPrinterSize(printerSize)
            invoice.setLogo(userImage);
            invoice.setTicketLogo(ticketLogo);
            invoice.setExchange(localExchange || 0)
            invoice.setPrintLogoInvoice(settings?.printLogoInvoice || "");
            invoice.setPrintLogoTicket(settings?.printLogoTicket || "");
            await invoice.sendInvoice();

            arr.push({
                items: invoice.invoice.items,
                invoiceNumber: invoice.responseInvoice?.invoiceNumber,
                totalAmount: invoice.responseInvoice?.totalAmount,
                sdcDateTime: invoice.responseInvoice?.sdcDateTime,
            })

            const startCharCode = 'a'.charCodeAt(0);
            for (let i = 0; i < Number(quantity); i++) {
                const charCode = startCharCode + (i % 26);
                const letter = String.fromCharCode(charCode);
                const id = `${invoice.totalCounter}${letter}`;
                await invoice.printPeron(id, additional, user);
              upsertPlatformTicket({
                token_value: id,
                pass_model: "SINGLE",
                max_passes: 1,
                operatorId: additional?.operatorId || null,
                type: "qr",
                valid_from: new Date().toISOString(),
                valid_to: moment().endOf("day").toISOString(),
              }).catch((reason) => {
                console.error("upsertPlatformTicket", reason);
              });
            }

            await invoice.printInvoice(invoice.invoice, invoice.responseInvoice);
            if (onSuccess) {
                onSuccess();
            }
            setPrintedInvoices(arr)
            onClose();
        } catch (error) {
            console.error("handleSubmitPaymentDialog", error);
            if (typeof error === "string") {
                return enqueueSnackbar(error, {variant: "error"});
            }
            return enqueueSnackbar(error?.message, {variant: "error"});
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open={open} onClose={loading ? null : onClose}>
            <form>
                <DialogTitle>Fiskalizacija perona</DialogTitle>
                <DialogContent>
                    <Divider sx={{borderStyle: "dashed", mb: 1}}>
                        <Chip label="Količina" variant="outlined"/>
                    </Divider>
                    <TextField
                        size="small"
                        label="Količina"
                        fullWidth
                        autoFocus
                        type="number"
                        value={quantity}
                        onChange={e => setQuantity(e.target.value)}
                    />
                    <Divider sx={{borderStyle: "dashed", my: 1}}>
                        <Chip label={"Načini plaćanja"} variant="outlined"/>
                    </Divider>
                    <ToggleButtonGroup
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            flexWrap: "wrap"
                        }}>
                        {filteredPayments.map((method, index) =>
                            <MethodButton
                                key={`payment-method-${method.name}-${index}`}
                                onClick={handleMethodClick}
                                method={method}
                                selectedPayments={selectedPayments}/>
                        )}
                    </ToggleButtonGroup>
                    <Card sx={{
                        //textTransform: "capitalize",
                        color: (theme) => (theme.palette.mode === "light" ? "primary.darker" : "primary.lighter"),
                        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
                        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
                        paddingX: 3,
                        paddingY: 2
                    }}>
                        <Stack direction="column" spacing={1}>
                            <Typography variant="button" color="dimgrey">
                                Ukupan iznos za uplatu: {fCurrency(roundTotal.toString())} RSD
                            </Typography>
                            <Stack direction="row" spacing={1}>
                                {selectedPayments.map((value, index) =>
                                    <TextField
                                        size="small"
                                        autoFocus={index === 0}
                                        key={`selected-payment-${index}-${value.paymentType}`}
                                        sx={{
                                            maxWidth: 150
                                        }}
                                        label={getLabel(value.paymentType)}
                                        value={value.amount}
                                        name={value.paymentType}
                                        onChange={(event) => handleChangeAmount(event, index)}
                                    />
                                )}
                            </Stack>
                            {exchange > 0 ?
                                <Typography variant="button" color="dimgrey">
                                    Kusur: {fCurrency(exchange.toString())}
                                </Typography> :
                                exchange < 0 ? <Typography variant="button" color="darkRed">
                                    Uneli ste manji iznos od predviđenog: {fCurrency(exchange.toString())}
                                </Typography> : <Typography variant="button"/>
                            }
                        </Stack>
                    </Card>
                </DialogContent>
                <DialogActions>
                    <Button disabled={loading} variant="outlined" color="inherit" onClick={onClose}>
                        Otkaži [ESC]
                    </Button>
                    <LoadingButton disabled={exchange < 0} loading={loading} onClick={handleIssuePlatformCard}
                                   variant="contained">
                        Prihvati
                    </LoadingButton>
                </DialogActions>
            </form>

        </Dialog>
    );
}

const getLabel = (method) => {
    return SETTINGS_PAYMENTS.find(localMethod => localMethod.value === method).displayName;
};
